import { useEffect, useState } from 'react';

const MINUTE_MS = 60_000;

/**
 * The current time in epoch ms, refreshed once a minute on the minute
 * boundary. A local timer only: it re-renders the caller, it fetches nothing.
 */
export function useMinuteNow(): number {
  const [now, setNow] = useState(Date.now);

  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | undefined;
    const timeout = setTimeout(
      () => {
        setNow(Date.now());
        interval = setInterval(() => setNow(Date.now()), MINUTE_MS);
      },
      MINUTE_MS - (Date.now() % MINUTE_MS),
    );
    return () => {
      clearTimeout(timeout);
      if (interval !== undefined) clearInterval(interval);
    };
  }, []);

  return now;
}
